// import html5 from "../../assets/htm5.png";

import taxactindia from "../assets/taxactindia.png";
import nammadoors from "../assets/nammadoors.png";
import maeoil from "../assets/maeoil.png";
import dmtechtree from "../assets/dmtechtree.png";
import beyondbooksorg from "../assets/beyondbooksorg.png";

const Recent_project_list = [
  {
    img: taxactindia,
    name: "Taxactindia.in",
    description:
      "Taxactindia help our client with updated information related to GST, Income Tax, Professional Tax, PAN, TAN, E-TDS,Tax payment Challans, Income Tax Calculations and Latest Notifications",
    src: "http://taxactindia.in/",
  },
  {
    img: nammadoors,
    name: "Nammadoors.com",
    description:
      "Since 1975, Namma doors has spent more than 30 years in designing Doors, Frames and Windows. Adopted proven door manufacturing methodologies to carve finest doors for your dream homes ",
    src: "https://nammadoors.com/",
  },
  {
    img: maeoil,
    name: "Maeoil.com",
    description:
      "Maeoil prioritise purity and quality in all of our products which includes our extraction and processing of our oils. This indeed has kept our product Reputation at its zenith",
    src: "http://maeoil.com/",
  },
  {
    img: dmtechtree,
    name: "Dmtechtree.com",
    description:
      "Dmtechtree one of the best consulting and outsourcing firms, helping you to move forward and get sustainable results",
    src: "http://dmtechtree.com/",
  },
  {
    img: beyondbooksorg,
    name: "Beyondbooksorg.in",
    description:
      "We are the facilitators to facilitate anything and everything related to education in india & abroad",
    src: "http://beyondbooksorg.in/",
  },
];

export default Recent_project_list;
